import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import afsLogo from './AFS_wordmark_horizontal_white.svg';
import styles from './styles.module.scss';
export default function Footer() {
  const version = import.meta.env.VITE_VERSION ?? '0.0.0';
  return (
    <footer
      role="contentinfo"
      aria-roledescription="VA Page Footer"
      id="footer"
      className={`${styles.footer} mt-auto pt-3 pb-4 text-white text-center text-sm-start`}
    >
      <Container fluid>
        <Row>
          <Col sm={6}>
            <p>
              <small>
                &copy;{`${new Date().getFullYear()} All Rights Reserved`}
              </small>
            </p>
          </Col>
          <Col sm={6} className="text-end pe-0">
            <div>
              <a
                id="a1683300-0d6f-11ea-8d71-362b9e155667"
                href="https://www.accenture.com/us-en/industries/accenture-federal-services"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={afsLogo}
                  alt="Accenture Federal Services"
                  className="d-print-none"
                  height={50}
                />
              </a>
            </div>
            <div className="pe-3">Version {version}</div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
